(function () {
    'use strict';

    angular.module('swif.achats')

    .factory('AchatsStocksConfigurationService', ['$q', 'swifFrameworkService',
        function ($q, swif) {
            var service = {};
            service.analytics = {};
            service.analytics.id = 'analytics';
            service.analytics.collection = undefined;
            service.analytics.getCollection = function () {
                return swif.collection.getCollection(service.analytics.id);
            };
            service.analytics.createCollection = function () {
                return swif.collection.createOrUpdate(
                    service.analytics.id,
                    'account_analytic_account',
                    {},
                    {location: true}
                );
            };

            service.validations = {};
            service.validations.id = 'validations';
            service.validations.collection = undefined;
            service.validations.getFilter = function () {
                var ret = {};
                swif.data.addExtraFilter(ret, 'purchase', 'is_purchase', '=', true);
                return ret;
            };
            service.validations.getCollection = function () {
                return swif.collection.getCollection(service.validations.id);
            };
            service.validations.createCollection = function () {
                var filter = service.validations.getFilter();
                return swif.collection.createOrUpdate(
                    service.validations.id,
                    'validation-block-template',
                    filter,
                    {location: true}
                );
            };

            service.validations.preModal = function (data) {
                data.model.creator_id = [false, ''];
                data.model._context = {purchase: true};
                if (data.action.id === 'add') {
                    data.model.is_purchase = true;
                    data.model.purchase_threshold = 0.0;
                    data.model.operator = 'next';
                    data.model.name = '';
                    data.model.items = [];
                } else {
                    var val = swif.validation.getTemplateFromServer(data.model.id);
                    data.model.items = val.items;
                }
            };

            service.validations.preValidate = function (data) {
                var ret = true;
                var val = swif.validation.prepareObjectForSave(data.model);
                _.merge(data.model, val);
                if (data.action.id === 'add') {
                    ret = swif.data.create('validation-block-template', data.model);
                } else if (data.action.id === 'edit') {
                    ret = swif.data.save('validation-block-template', data.model.id, data.model);
                }
                return ret;
            };

            service.validations.callback = function (error, data) {
                if (data.action.id === 'add') {
                    service.validations.getCollection().getItems();
                    swif.collection.defaultCallbackMessage(error, data);
                }
                else if (data) {
                    service.validations.getCollection().fasterCallback(data);
                } else {
                    swif.collection.defaultCallbackMessage(error, data);
                }
            };

            service.invoiceValidations = {};
            service.invoiceValidations.id = 'invoiceValidations';
            service.invoiceValidations.collection = undefined;
            service.invoiceValidations.getFilter = function () {
                var ret = {};
                swif.data.addExtraFilter(ret, 'purchase', 'is_purchase_invoice', '=', true);
                return ret;
            };
            service.invoiceValidations.getCollection = function () {
                return swif.collection.getCollection(service.invoiceValidations.id);
            };
            service.invoiceValidations.createCollection = function () {
                var filter = service.invoiceValidations.getFilter();
                return swif.collection.createOrUpdate(
                    service.invoiceValidations.id,
                    'validation-block-template',
                    filter,
                    {location: true}
                );
            };

            service.invoiceValidations.preModal = function (data) {
                data.model.creator_id = [false, ''];
                data.model._context = {invoice: true};
                // that is crapy ....
                data.action.modal.title = data.action.modal.title.replace('commande', 'facture');
                if (data.action.id === 'add') {
                    data.model.is_purchase_invoice = true;
                    data.model.purchase_threshold = 0.0;
                    data.model.operator = 'next';
                    data.model.name = '';
                    data.model.items = [];
                } else {
                    var val = swif.validation.getTemplateFromServer(data.model.id);
                    data.model.items = val.items;
                }
            };

            service.invoiceValidations.preValidate = function (data) {
                var ret = true;
                var val = swif.validation.prepareObjectForSave(data.model);
                _.merge(data.model, val);
                if (data.action.id === 'add') {
                    ret = swif.data.create('validation-block-template', data.model);
                } else if (data.action.id === 'edit') {
                    ret = swif.data.save('validation-block-template', data.model.id, data.model);
                }
                return ret;
            };

            service.invoiceValidations.callback = function (error, data) {
                if (data.action.id === 'add') {
                    service.invoiceValidations.getCollection().getItems();
                    swif.collection.defaultCallbackMessage(error, data);
                }
                else if (data) {
                    service.invoiceValidations.getCollection().fasterCallback(data);
                } else {
                    swif.collection.defaultCallbackMessage(error, data);
                }
            };

            service.warehouses = {};
            service.warehouses.id = 'warehouses';
            service.warehouses.collection = undefined;
            service.warehouses.getCollection = function () {
                return swif.collection.getCollection(service.warehouses.id);
            };
            service.warehouses.createCollection = function () {
                var filter = {};
                swif.data.sortOn(filter, 'id', 'desc');
                return swif.collection.createOrUpdate(
                    service.warehouses.id,
                    'stock_warehouse',
                    filter,
                    {location: true}
                );
            };
            service.resolveData = function () {
                return swif.route.check().then(function () {
                    var ret = $q.defer();
                    var deferred = [];
                    deferred.push(service.analytics.createCollection());
                    deferred.push(service.validations.createCollection());
                    deferred.push(service.invoiceValidations.createCollection());
                    deferred.push(service.warehouses.createCollection());
                    // add other collections into 'deferred' (if needed)
                    $q.all(deferred).then(function (data) {
                        var ndata = {
                            analytics: data[0],
                            validations: data[1],
                            invoiceValidations: data[2],
                            warehouses: data[3]
                        };
                        ret.resolve(ndata);
                    });
                    return ret.promise;
                });
            };

            service.refresh = function (loader) {
                swif.message.loading(loader);
                var deferred = [];
                _.forEach([
                    service.analytics.id,
                    service.validations.id,
                    service.invoiceValidations.id,
                    service.warehouses.id
                ], function (name) {
                    var collection = swif.collection.getCollection(name);
                    if (collection) {
                        deferred.push(collection.getItems());
                    }
                });
                $q.all(deferred).then(function () {
                    swif.message.loading(loader, 'ok');
                }, function () {
                    swif.message.loading(loader, 'ko');
                });
            };
            return service;
        }
    ])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/achats-stocks/configuration_view', {
            templateUrl: 'partials/achats/configuration_view.html',
            controller: 'AchatsStocksConfigurationController',
            reloadOnSearch: false,
            resolve: {
                data: ['AchatsStocksConfigurationService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }])

    .controller('AchatsStocksConfigurationController', [
        '$scope', '$q', 'swifFrameworkService', 'AchatsStocksConfigurationService', 'data', 'AchatsService',
        function ($scope, $q, swif, service, data, achats) {
            swif.settings.page.title = 'Achats module configuration';
            $scope.modules = swif.module.modules;

            $scope.loading = {items: {}};
            $scope.collections = {
                validations: data.validations,
                invoiceValidations: data.invoiceValidations,
                warehouses: data.warehouses
            };
            $scope.is = achats.rights.getPermissions();
            $scope.refresh = function () {
                service.refresh($scope.loading);
            }

            $scope.validations = {};
            $scope.validations.preModal = service.validations.preModal;
            $scope.validations.preValidate = service.validations.preValidate;
            $scope.validations.callback = service.validations.callback;

            $scope.invoiceValidations = {};
            $scope.invoiceValidations.preModal = service.invoiceValidations.preModal;
            $scope.invoiceValidations.preValidate = service.invoiceValidations.preValidate;
            $scope.invoiceValidations.callback = service.invoiceValidations.callback;
        }
    ])

    .controller('PurchasesParamsController' ,[
        '$scope', 'swifOpenbaseCompanyService', 'swifFrameworkService',
        function ($scope, swifOpenbaseCompanyService, swif) {
            $scope.modules = swif.module.modules;

            $scope.helpText = "Applicable seulement aux utilisateurs gestionnaires des modules Interventions ET Achats Stocks.";

            swifOpenbaseCompanyService.getGlobalSettingsPurchases().then(function(company) {
                $scope.globalSettingsPurchases = company;
                swif.settings.initialize().then(settings => {
                    $scope.choices = {
                        purchase_order: swif.settings.getContentType('purchase_order').defaultStates,
                        consumables_req_states: swif.settings.getContentType('openstc_ask_prod').defaultStates,
                    }

                    _.forEach($scope.choices.consumables_req_states, function (item) {
                        if ($scope.globalSettingsPurchases.default_consumables_req_state === item.id){
                            $scope.globalSettingsPurchases.default_consumables_req_state = [item.id, item.name];
                        }
                    });

                    _.forEach($scope.choices.purchase_order, function (item) {
                        if ($scope.globalSettingsPurchases.default_po_state === item.id) {
                            $scope.globalSettingsPurchases.default_po_state = [item.id, item.name];
                        }
                    });
                });
            });
            $scope.saveGlobalSettingsPurchases = function () {
                swifOpenbaseCompanyService.saveCompany($scope.globalSettingsPurchases);
            };


            $scope.$watch('globalSettingsPurchases.default_po_state', function (newV) {
                if (newV !== undefined) {
                    if (['confirmed','done','delivered'].includes(newV[0])) {
                        $scope.budgetRequired = true;
                    } else {
                        $scope.budgetRequired = false;
                    }
                }
            });
        }
    ])

    .controller('AchatsStocksAnalyticModalController',[
        '$scope', 'swifFrameworkService', 'AchatsStocksConfigurationService',
        function ($scope, swif, service) {
            $scope.filters = {
                parent_id: undefined
            };
            var currentId = $scope.model.id || 0;
            swif.data.addFilter($scope.filters.parent_id, '|');
            swif.data.addFilter($scope.filters.parent_id, 'id', '!=', currentId);
            swif.data.addFilter($scope.filters.parent_id, 'parent_id', '!=', currentId);
        }
    ])

    .controller('AchatsStocksValidationTemplateModalController',[
        '$scope', 'swifFrameworkService', 'AchatsStocksConfigurationService',
        function ($scope, swif, service) {
            $scope.filters = {
                users: {}
            };
            var show = $scope.action.id === 'read';
            var init = $scope.action.id === 'add';
            $scope.initialize = init;
            $scope.readonly = show;
            if ($scope.model._context.purchase) {
                swif.data.addFilter($scope.filters.users, 'groups_id.code', '=', 'purchase_order_confirm');
            } else if ($scope.model._context.invoice) {
                swif.data.addFilter($scope.filters.users, 'groups_id.code', '=', 'purchase_order_manage_invoice');
            }

        }
    ])

    .controller('AchatsStockWarehouseController', [
        '$scope', 'swifFrameworkService',
        function ($scope, swif) {
            $scope.filters = {
                users: {},
            };
            swif.data.addFilter($scope.filters.users, 'access_rights', 'ilike', 'stock_config');
            $scope.$watch('model.parent_id', function (newV, oldV) {
                    if (!angular.equals(newV, oldV) && newV != false) {
                        let warehouseFilter = { fields: ['user_ids'] };
                        swif.data.addFilter(warehouseFilter, 'id', '=', $scope.model.parent_id[0]);

                        swif.data.get('stock_warehouse', undefined, warehouseFilter).then(function (data) {
                            $scope.model.user_ids = _.union($scope.model.user_ids, data[0].user_ids)
                        })
                    }
            }, true);
        }
    ]);
})();
